import type { CardOperationStatus } from './card.types';

/** Statuses surfaced by the «Needs attention» quick filter: failures and refunds. */
export const ATTENTION_OPERATION_STATUSES: readonly CardOperationStatus[] = [
  'FAILED',
  'REFUND_PENDING',
  'REFUNDED',
  'REFUND_FAILED',
];

/**
 * One choice in the operations status filter. Statuses that share a user-facing
 * label (BATCHED / PROVIDER_PENDING → "Crediting to card") collapse into a
 * single group so the dropdown never shows duplicate entries.
 */
export interface CardOperationStatusGroup {
  readonly value: string;
  readonly statuses: readonly CardOperationStatus[];
  readonly labelKey: string;
}

export const CARD_OPERATION_STATUS_GROUPS: readonly CardOperationStatusGroup[] = [
  { value: '', statuses: [], labelKey: 'cards.ops.anyStatus' },
  { value: 'CREATED', statuses: ['CREATED'], labelKey: 'cards.ops.status.CREATED' },
  { value: 'FUNDING', statuses: ['FUNDING'], labelKey: 'cards.ops.status.FUNDING' },
  { value: 'FUNDED', statuses: ['FUNDED'], labelKey: 'cards.ops.status.FUNDED' },
  {
    value: 'CREDITING',
    statuses: ['BATCHED', 'PROVIDER_PENDING'],
    labelKey: 'cards.ops.status.BATCHED',
  },
  { value: 'COMPLETED', statuses: ['COMPLETED'], labelKey: 'cards.ops.status.COMPLETED' },
  { value: 'FAILED', statuses: ['FAILED'], labelKey: 'cards.ops.status.FAILED' },
  {
    value: 'REFUND_PENDING',
    statuses: ['REFUND_PENDING'],
    labelKey: 'cards.ops.status.REFUND_PENDING',
  },
  { value: 'REFUNDED', statuses: ['REFUNDED'], labelKey: 'cards.ops.status.REFUNDED' },
  {
    value: 'REFUND_FAILED',
    statuses: ['REFUND_FAILED'],
    labelKey: 'cards.ops.status.REFUND_FAILED',
  },
];

/** `''` (any) and unknown group values match every operation. */
export function operationStatusMatchesGroup(
  status: CardOperationStatus,
  groupValue: string,
): boolean {
  if (groupValue === '') return true;
  const group = CARD_OPERATION_STATUS_GROUPS.find(g => g.value === groupValue);
  return group ? group.statuses.includes(status) : true;
}
